module.exports = "<div ng-class=\"{ &quot;is-hoverable&quot;: tag.isHoverable }\" class=\"cui-tag\"><ng-transclude></ng-transclude><div cian-ui-icon=\"cian-ui-icon\" name=\"close\" ng-if=\"tag.onClose\" ng-click=\"tag.onClose()\" class=\"cui-tag__close\"></div></div>"


//////////////////
// WEBPACK FOOTER
// ./~/@cian/ui/app/components/tag/template.jade
// module id = 897
// module chunks = 0